import React from 'react'
import { CardElement, injectStripe } from 'react-stripe-elements'

// Components
import Loader from 'app/views/components/Loader'

// Settings
import settings from 'settings'

// Utils
import { api } from 'app/views/utils/api'


class CheckoutForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loadingButton: false,
      formMessage: '',
      formError: '',
      licenseCount: 1,
      couponCode: '',
      price: '750.00',
      amountOff: 0,
      percentOff: 0,
      couponError: '',
    }

    this.submitCouponCode = this.submitCouponCode.bind(this)
    this.handleCouponCodeChange = this.handleCouponCodeChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleCouponCodeChange(e) {
    this.setState({
      couponError: '',
      couponCode: e.target.value,
    })
  }

  async handleSubmit(e) {
    e.preventDefault()

    this.setState({ loadingButton: true })

    // charge card
    const { token } = await this.props.stripe.createToken({ name: this.props.email })

    if (token) {
      api({
        method: 'post',
        url: `${settings.urls.hacker}/charge`,
        data: {
          coupon: this.state.couponCode,
          token: token.id,
          license_count: this.state.licenseCount,
          email: this.props.email,
          name: this.props.email,
          company: this.props.email,
          phone: '+0 000-000-0000',
        },
      })
        .then((response) => {
          if (response.data.success === true) {
            let message = `Upgrade Individual (PAID)!\nEmail: ${this.props.email}`

            const refName = localStorage.getItem('hackedu.ref.name')
            const refDate = localStorage.getItem('hackedu.ref.date')
            if (refName) {
              message = `${message}\nReference: ${refName} on ${refDate}`
            }

            api({
              method: 'post',
              url: `${settings.urls.hacker}/contact`,
              data: {
                name: this.props.email,
                email: this.props.email,
                message,
              },
            })
              .then((response) => {
                if (response.data.success === true) {
                  this.setState({
                    couponError: '',
                    formMessage: 'Thank you for signing up! Your account will be upgraded shortly.',
                    formError: '',
                    loadingButton: false,
                  })
                } else {
                  this.setState({
                    loadingButton: false,
                    formError: 'Whoops! Something went wrong.',
                    formMessage: '',
                  })
                }
              })
              .catch((error) => {
                console.error(error)
                this.setState({
                  loadingButton: false,
                  formError: 'Whoops! Something went wrong. [0]',
                  formMessage: '',
                })
              })
          } else {
            this.setState({
              loadingButton: false,
              formError: 'Whoops! Something went wrong. [1]',
              formMessage: '',
            })
          }
        })
        .catch((error) => {
          console.error(error)
          if (error.response.data.error) {
            this.setState({
              formError: error.response.data.error,
              formMessage: '',
              loadingButton: false,
            })
          } else {
            this.setState({
              formError: 'Whoops! Something went wrong. [2]',
              formMessage: '',
              loadingButton: false,
            })
          }
        })
    } else {
      // token was not generated
      this.setState({
        loadingButton: false,
        formError: 'Your card could not be processed.',
        formMessage: '',
      })
      console.error('Your card could not be processed.')
    }
  }

  async submitCouponCode(e) {
    e.preventDefault()

    api({
      method: 'post',
      url: `${settings.urls.hacker}/coupon`,
      data: { coupon: this.state.couponCode },
    })
      .then((response) => {
        if (response.data.valid) {
          if (response.data.amount_off > 0) {
            this.setState({
              couponError: '',
              amountOff: response.data.amount_off,
              price: this.calculatePrice(this.state.licenseCount, response.data.amount_off, false),
            })
          } else if (response.data.percent_off > 0) {
            this.setState({
              couponError: '',
              percentOff: response.data.percent_off,
              price: this.calculatePrice(this.state.licenseCount, false, response.data.percent_off),
            })
          }
        } else {
          this.setState({
            couponError: 'Coupon is not valid.',
            formError: '',
            formMessage: '',
          })
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  calculatePrice(licenseCount, amountOff, percentOff) {
    let price = licenseCount * 75000
    if (amountOff) {
      price = price - amountOff
    } else if (percentOff) {
      price = price * (100 - percentOff) / 100
    }
    price = (price / 100).toFixed(2)
    return price
  }

  render() {
    if (this.props.email === null) {
      return <Loader visible />
    }
    return (
      <div className="uk-container-cover uk-background-muted">
        <div className="uk-section">
          <div className="uk-container uk-container-large">
            <div data-uk-grid>
              <div className="uk-width-3-5@s uk-width-2-3@l">
                <div className="uk-card uk-card-default uk-card-body">
                  <form className="uk-form-horizontal">
                    <fieldset className="uk-fieldset">
                      <legend className="uk-legend">Upgrade Account</legend>

                      <div className="uk-margin">
                        <span className="uk-form-label uk-text-right">Email</span>
                        <div data-uk-grid>
                          <div className="uk-width-1-1" style={{ marginTop: 7 }}>
                            {this.props.email}
                          </div>
                        </div>
                      </div>

                      <div className="uk-margin">
                        <span className="uk-form-label uk-text-right">Credit Card</span>
                        <div data-uk-grid>
                          <div className="uk-width-1-1">
                            <div style={{ border: '1px solid #e5e5e5', padding: 11 }}>
                              <CardElement />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="uk-margin" data-uk-margin>
                        <span className="uk-form-label uk-text-right">Coupon Code</span>
                        <div data-uk-grid>
                          <div className="uk-width-1-1">
                            <div data-uk-form-custom="target: true">
                              <input
                                className="uk-input uk-form-width-medium"
                                type="text"
                                placeholder="Coupon Code..."
                                onChange={this.handleCouponCodeChange}
                                value={this.state.couponCode}
                              />
                            </div>
                            <button
                              type="button"
                              className="uk-button uk-button-default"
                              onClick={this.submitCouponCode}
                              style={{ borderRadius: 0 }}
                            >
                              <span data-uk-icon="icon: refresh" />
                            </button>
                            {(this.state.couponError) && (
                              <p className="uk-text-danger">{this.state.couponError}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="uk-margin">
                        <span className="uk-form-label uk-text-right">Price</span>
                        <div data-uk-grid style={{ paddingTop: 7 }}>
                          <div className="uk-width-1-1">
                            {`$${this.state.price}`}
                          </div>
                        </div>
                      </div>

                      <div className="uk-margin">
                        <span className="uk-form-label uk-text-right" />
                        <div data-uk-grid>
                          <div className="uk-width-1-1">
                            {this.state.loadingButton ? (
                              <span data-uk-spinner="" />
                            ) : (
                              <div>
                                { this.state.formMessage !== '' && (
                                  <div className="uk-text-primary">
                                    {this.state.formMessage}
                                  </div>
                                )}
                                { this.state.formError !== '' && (
                                  <div className="uk-text-danger">
                                    {this.state.formError}
                                  </div>
                                )}
                                <button type="submit" className="uk-button uk-button-primary tm-button-primary" onClick={this.handleSubmit}>Submit Payment</button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
              <div className="uk-width-2-5@s uk-width-1-3@l">
                <div className="uk-card uk-card-default uk-card-body">
                  <h3>Summary</h3>
                  <table className="uk-table uk-table-small" style={{ marginBottom: 0 }}>
                    <tbody>
                      <tr>
                        <th className="uk-text-right" style={{ width: 100 }}>License Count</th>
                        <td>{this.state.licenseCount}</td>
                      </tr>
                    </tbody>
                  </table>
                  {(this.state.licenseCount < 10) && (
                    <table className="uk-table uk-margin-remove uk-table-small">
                      <tbody>
                        {(this.state.amountOff) ? (
                          <tr>
                            <th className="uk-text-right" style={{ width: 100 }}>Discount</th>
                            <td>
                              {`$${this.state.amountOff}`}
                            </td>
                          </tr>
                        ) : (
                          <tr />
                        )}
                        {(this.state.percentOff) ? (
                          <tr>
                            <th className="uk-text-right" style={{ width: 100 }}>Discount</th>
                            <td>
                              {`${this.state.percentOff}%`}
                            </td>
                          </tr>
                        ) : (
                          <tr />
                        )}
                        <tr>
                          <th className="uk-text-right" style={{ width: 100 }}>Price</th>
                          <td>
                            {`$${this.state.price}`}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default injectStripe(CheckoutForm)
